import { Navigate, useParams } from "react-router-dom";
import AddressValid from "../../views/Admin/AddressValid";
import ChangeLog from "../../views/Admin/ChangeLog";
import Changes from "../../views/Admin/Changes";
import CreateNotification from "../../views/Admin/CreateNotification";
import UserManagement from "../../views/Admin/UserManagement";
import AdminCenter from "../../views/Admin/Hub/AdminCenter";
import PageAccess from "../../views/Admin/Access/PageAccess";
import { ACCESS_ROLES } from "../../views/Admin/Access/accessApi";
import SignatureManager from "../../views/Admin/SignatureManager";
import GrangerYardMap from "../../views/Admin/GrangerYardMap";
import InsertKit from "../../views/Dashboard/DoorBuilder/InsertKit";
import Messages from "../../views/Dashboard/Messages/Messages";
import ScheduleOrders from "../../views/Dashboard/Orders/ScheduleOrders";
import ExteriorOrders from "../../views/Dashboard/WindowDoor/ExteriorOrders";
import DashboardHome from "../../views/Dashboard/WindowDoor/RequestList";
import WindowQuoteManager from "../../views/Dashboard/WindowDoor/WindowQuoteManager";
import WindowFormsAdminSettings from "../../views/Dashboard/WindowDoor/WindowFormsAdminSettings";
import WindowFormDetail from "../../views/Dashboard/WindowDoor/WindowFormDetail";
import WindowFormsSalesDashboard from "../../views/Dashboard/WindowDoor/WindowFormsSalesDashboard";
import WindowFormSalesDetail from "../../views/Dashboard/WindowDoor/WindowFormSalesDetail";
import WindowFormsAssignedDashboard from "../../views/Dashboard/WindowDoor/WindowFormsAssignedDashboard";
import RequestSummary from "../../views/Dashboard/WindowDoor/RequestSummary";
import Requests from "../../views/Dashboard/WindowDoor/Requests";
import AcceptRequest from "../../views/Dashboard/WindowDoor/Requests/accept";
import AcceptAlt from "../../views/Dashboard/WindowDoor/Requests/acceptAlt";
import RejectRequest from "../../views/Dashboard/WindowDoor/Requests/reject";
import ScheduleEarliest from "../../views/Dashboard/WindowDoor/Requests/schEarliest";
import NotFound from "../../views/Error/NotFound";
import LocationManager from "../../views/Fleet/Forklifts/LocationManager";
import LocationDetail from "../../views/Fleet/Forklifts/LocationDetail";
import ViewEntries from "../../views/Forms/Dashboard/ViewEntries";
import InteriorDoor from "../../views/Forms/Door/InteriorDoor";
import Drafts from "../../views/Forms/Misc/Drafts";
import QuoteOrderForm from "../../views/Forms/QuoteOrderForm";
import Help from "../../views/Help/Help";
import Home from "../../views/Home/Home";
import Profile from "../../views/Profile/profile";
import ManagerLeads from "../../views/Webleads/ManagerLeads";
import SalesLeads from "../../views/Webleads/SalesLeads";
import Summary from "../../views/Webleads/Summary";
import SummaryBranchSpecific from "../../views/Webleads/SummaryBranchSpecific";
import WebLead from "../../views/Webleads/WebLead";
import InitUser from "../InitUser/InitUser";
import DoorBuilder from "../WindowDoor/DoorBuilder";
import Weather from "../../views/Dashboard/Weather";
import ForkliftForm from "../../views/Fleet/Forklifts/ForkliftForm";
import ForkDisplay from "../../views/Fleet/Forklifts/ForkDisplay";
import DisplayEntries from "../../views/Fleet/Forklifts/DisplayEntries";
import Logout from "../../auth/Logout";
import LeadMap from "../../views/WebleadsV3/LeadMap";
import WindowServiceRequestForm from "../../views/Forms/WindowDoor/WindowServiceRequestForm";
import ServiceRequestsDashboard from "../../views/Dashboard/WindowDoor/ServiceRequests/ServiceRequestsDashboard";
import ServiceRequestDetail from "../../views/Dashboard/WindowDoor/ServiceRequests/ServiceRequestDetail";
import MyServiceRequests from "../../views/Dashboard/WindowDoor/ServiceRequests/MyServiceRequests";
import MyServiceRequestDetail from "../../views/Dashboard/WindowDoor/ServiceRequests/MyServiceRequestDetail";
import RemodelForm from "../../views/Forms/Remodel/RemodelForm";
import FormsHub from "../../views/Forms/Hub/FormsHub";
import MySubmissions from "../../views/Forms/Hub/MySubmissions";
import TaxCert from "../../views/Misc/TaxCert";
import ManagePhone from "../../views/Admin/ManagePhone";
import FleetHome from "../../views/Fleet/FleetHome";
import ForkliftList from "../../views/Fleet/ForkliftList";
import ForkliftDetail from "../../views/Fleet/ForkliftDetail";
import VehicleList from "../../views/Fleet/VehicleList";
import VehicleDetail from "../../views/Fleet/VehicleDetail";
import InspectionLog from "../../views/Fleet/InspectionLog";
import { FLEET_ROLES } from "../../views/Fleet/fleetApi";
import SharePoint from "../../views/Dashboard/SharePoint";
import WithoutContact from "../../views/Webleads/WithoutContact";
import ConvertedToSale from "../../views/Webleads/ConvertedToSale";
import CustomerKPIs from "../../views/Dashboard/CustomerKPIs";
import RequestAccess from "../../views/Misc/RequestAccess";
import ExternalAuth from "../Navigation/ExternalAuth";
import CommonStock from "../../views/SBCF/CommonStock";
import UserPortal from "../../views/Admin/UserPortal";
import DoorPricing from "../../views/Admin/DoorPricing";
import UserChecklist from "../../views/Admin/UserChecklist";
import InteriorDoorFormSummary from "../../views/Forms/Door/InteriorDoorFormSummary";
import SummaryNew from "../../views/Webleads/SummaryNew";
import WebLeadsPage from "../../views/WebleadsV3/WebLeadsPage";
import WebleadManager from "../../views/WebleadsV2/WebleadManager";
import RecognitionForm from "../../views/Forms/Misc/RecognitionForm";
import OrderProblemForm from "../../views/Forms/Misc/OrderProblemForm";
import RecognitionEntries from "../../views/Forms/Misc/RecognitionEntries";
import TrendEditor from "../../views/Admin/WebsiteEditor";
import WebsiteEditor from "../../views/Admin/WebsiteEditor";
import MillScanner from "../../views/Misc/MillScanner";
import BlueprintSpecSheet from "../../views/SBCF/BlueprintSpecSheet";
import SalesSchedule from "../../views/SBCF/SalesSchedule";
import SBCFDashboard from "../../views/SBCF/SBCFDashboard";
import SBCFAdminDashboard from "../../views/SBCF/SBCFAdminDashboard";
import StepCompetition from "../../views/Misc/StepComp";
import WebtrackMonitor from "../../views/Misc/WebtrackMonitor";
import CRMDashboard from "../../views/Sales/CRMDashboard";
import MaterialListAi from "../../views/Sales/MaterialListAi";
import CabinetQuoteList from "../../views/CabinetQuotes/CabinetQuoteList";
import NewCabinetQuote from "../../views/CabinetQuotes/NewCabinetQuote";
import CabinetQuoteWorkspace from "../../views/CabinetQuotes/CabinetQuoteWorkspace";
import CabinetAdmin from "../../views/CabinetQuotes/CabinetAdmin";
import CabinetDesignRender from "../../views/CabinetQuotes/CabinetDesignRender";
import CabinetQuoteCustomerPortal from "../../views/CabinetQuotes/CabinetQuoteCustomerPortal";
import OrderProblemsDashboard from "../../views/Delivery/OrderProblemsDashboard";
import FeatureRequestForm from "../../views/FeatureRequests/FeatureRequestForm";
import FeatureRequestsDashboard from "../../views/FeatureRequests/FeatureRequestsDashboard";
import LeadTimesManager from "../../views/Dashboard/WindowDoor/LeadTimes/LeadTimesManager";
import LeadTimesView from "../../views/Dashboard/WindowDoor/LeadTimes/LeadTimesView";
import SiteStatus from "../../views/Misc/SiteStatus";
import TruthChart from "../../views/Sales/TruthChart";
import PCWDashboard, { MillShopDashboard } from "../../views/PCW/PCWDashboard";
import ToolboxTalks from "../../views/Safety/ToolboxTalks";
import SafetyOverview from "../../views/Safety/SafetyOverview";
import SafetyConcerns from "../../views/Safety/SafetyConcerns";
import FireExtinguishers from "../../views/Safety/FireExtinguishers";
import TrainingVideos from "../../views/Safety/TrainingVideos";
import TrainingVideoDetail from "../../views/Safety/TrainingVideoDetail";
import ToolboxResults from "../../views/Safety/ToolboxResults";
import { SAFETY_ROLES } from "../../views/Safety/safetyApi";
import AppCodes from "../../views/Admin/AppCodes/AppCodes";
import { APP_CODES_ROLES } from "../../views/Admin/AppCodes/appCodesApi";
import AssistantUsage from "../../views/Admin/AssistantUsage/AssistantUsage";
import { ASSISTANT_USAGE_ROLES } from "../../views/Admin/AssistantUsage/assistantUsageApi";
import MonthlyFeedback from "../../views/Admin/Feedback/MonthlyFeedback";
import { FEEDBACK_ROLES } from "../../views/Admin/Feedback/feedbackApi";
import SignageDashboard from "../../views/Signage/SignageDashboard";
import Geomapping from "../../views/Tools/Geomapping";
import BuildingDesigner from "../../views/Tools/BuildingDesigner/LazyBuildingDesigner";

// The window forms admin area moved from /windowdoor/admin/windowforms to
// /windowdoor/quote-manager; old bookmarks and emailed links still resolve.
const RedirectWindowFormDetail = () => {
  const { id } = useParams();
  return <Navigate to={`/windowdoor/quote-manager/${id}`} replace />;
};

// The old Forklift Manager / Vehicle Manager "browse by location" pages
// became the Fleet lists' branch filter; bookmarks land pre-filtered.
const RedirectFleetView = ({ to }) => {
  const { location } = useParams();
  const branch = location && location !== "All" ? `?branch=${encodeURIComponent(location)}` : "";
  return <Navigate to={`${to}${branch}`} replace />;
};

export const routes = [
  {
    name: "Big C Node - Home",
    description: "Big C Node - Home",
    path: "/",
    roles: ["*"],
    component: <Home />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Big C Node - Initialize User",
    description: "Big C Node - Initialize User",
    path: "/inituser",
    roles: ["*"],
    component: <InitUser />,
    authHeader: false,
    footer: false,
  },

  {
    name: "Big C Node - Profile",
    description: "Big C Node - Profile",
    path: "/profile",
    roles: ["*"],
    component: <Profile />,
    authHeader: true,
    footer: true,
  },

  {
    name: "Big C Node - Cabinet Quote Dashboard",
    description: "View and track cabinet quotes.",
    path: "/cabinet-quotes",
    roles: ["*"],
    component: <CabinetQuoteList />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Big C Node - New Cabinet Quote",
    description: "Create a new cabinet quote.",
    path: "/cabinet-quotes/new",
    roles: ["*"],
    component: <NewCabinetQuote />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Big C Node - Cabinet Admin",
    description: "Manage cabinet templates and collaborators.",
    path: "/cabinet-quotes/admin",
    roles: ["Admin", "IT"],
    component: <CabinetAdmin />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Big C Node - AI Render Enhancer",
    description: "Make an existing cabinet render more photorealistic with AI.",
    path: "/cabinet-quotes/design-render",
    roles: ["*"],
    component: <CabinetDesignRender />,
    authHeader: true,
    footer: true,
  },

  {
    name: "Big C Node - Cabinet Quote Customer Portal",
    description: "Customer portal for a cabinet quote.",
    path: "/cabinet-quotes/customer/:token",
    roles: ["*"],
    component: <CabinetQuoteCustomerPortal />,
    authHeader: false,
    footer: false,
  },
  {
    name: "Big C Node - Cabinet Quote Workspace",
    description: "View and manage a cabinet quote.",
    path: "/cabinet-quotes/:quoteId",
    roles: ["*"],
    component: <CabinetQuoteWorkspace />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Big C Node - Exterior Orders",
    description: "Big C Node - Exterior Orders",
    path: "/windowdoor/exteriororders",
    roles: ["*"],
    component: <ExteriorOrders />,
    authHeader: true,
    footer: true,
  },

  {
    name: "Big C Node - Exterior Orders Summary",
    description: "Big C Node - Exterior Orders Summary",
    path: "/windowdoor/summary",
    roles: ["*"],
    component: <RequestSummary />,
    authHeader: true,
    footer: true,
  },

  {
    name: "Big C Node - Requests",
    description: "Big C Node - Requests",
    path: "/windowdoor/requests",
    roles: ["*"],
    component: <Requests />,
    authHeader: true,
    footer: true,
  },

  {
    name: "Accept Request - Exterior Orders",
    description: "Accept a request for exterior products.",
    path: "/acceptRequest/:id",
    roles: ["*"],
    component: <AcceptRequest />,
    authHeader: true,
    footer: true,
  },

  {
    name: "Reject Request - Exterior Orders",
    description: "Reject a request for exterior products.",
    path: "/rejectRequest/:id",
    roles: ["*"],
    component: <RejectRequest />,
    authHeader: true,
    footer: true,
  },

  {
    name: "Accept Alt Request - Exterior Orders",
    description: "Accept a request for exterior products.",
    path: "/acceptAlt/:ref",
    roles: ["*"],
    component: <AcceptAlt />,
    authHeader: true,
    footer: true,
  },

  {
    name: "Schedule Earliest Request - Exterior Orders",
    description: "Accept a request for exterior products.",
    path: "/schEarliest/:ref",
    roles: ["*"],
    component: <ScheduleEarliest />,
    authHeader: true,
    footer: true,
  },

  {
    name: "Dashboard Home - Admin",
    description: "View and manage all delivery requests for exterior products.",
    path: "/windowdoor/admin/requestlist",
    roles: ["*"],
    component: <DashboardHome />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Window Quote Manager",
    description:
      "Incoming window RFQ submissions, quoter assignments, and team workload.",
    path: "/windowdoor/quote-manager",
    roles: ["Window Door Manager", "Admin"],
    component: <WindowQuoteManager />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Window Form Manager",
    description: "Build window RFQ forms and manage notification settings.",
    path: "/windowdoor/quote-manager/settings",
    roles: ["Window Door Manager", "Window Door Staff", "Admin"],
    component: <WindowFormsAdminSettings />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Window Quote Manager - Detail",
    description: "Review a submitted window form.",
    path: "/windowdoor/quote-manager/:id",
    roles: ["Window Door Manager", "Admin"],
    component: <WindowFormDetail />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Window Quote Manager",
    description: "Redirects to the Window Quote Manager.",
    path: "/windowdoor/admin/windowforms",
    roles: ["Window Door Manager", "Admin"],
    component: <Navigate to="/windowdoor/quote-manager" replace />,
    authHeader: false,
    footer: false,
  },
  {
    name: "Window Form Manager",
    description: "Redirects to the Window Form Manager.",
    path: "/windowdoor/admin/windowforms/settings",
    roles: ["Window Door Manager", "Window Door Staff", "Admin"],
    component: <Navigate to="/windowdoor/quote-manager/settings" replace />,
    authHeader: false,
    footer: false,
  },
  {
    name: "Window Quote Manager - Detail",
    description: "Redirects to the Window Quote Manager detail view.",
    path: "/windowdoor/admin/windowforms/:id",
    roles: ["Window Door Manager", "Admin"],
    component: <RedirectWindowFormDetail />,
    authHeader: false,
    footer: false,
  },
  {
    name: "Window Forms - Sales",
    description: "View submitted window forms for sales.",
    path: "/windowdoor/sales/windowforms",
    roles: ["*"],
    component: <WindowFormsSalesDashboard />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Window Form - Sales Detail",
    description: "Review a submitted window form as sales.",
    path: "/windowdoor/sales/windowforms/:id",
    roles: ["*"],
    component: <WindowFormSalesDetail />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Window Forms - Assigned",
    description: "View assigned window forms.",
    path: "/windowdoor/staff/windowforms",
    roles: ["Window Door Staff", "Window Door Manager", "Admin"],
    component: <WindowFormsAssignedDashboard />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Window Form - Assigned Detail",
    description: "Review an assigned window form.",
    path: "/windowdoor/staff/windowforms/:id",
    roles: ["Window Door Staff", "Window Door Manager", "Admin"],
    component: <WindowFormDetail />,
    authHeader: true,
    footer: true,
  },

  {
    name: "Window Door Lead Times",
    description: "Current window and door lead times by brand.",
    path: "/windowdoor/lead-times",
    roles: ["*"],
    component: <LeadTimesView />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Lead Time Manager",
    description: "Manage brand lead times and email updates to sales.",
    path: "/windowdoor/lead-times/manage",
    roles: ["Window Door Manager", "Admin"],
    component: <LeadTimesManager />,
    authHeader: true,
    footer: true,
  },

  {
    name: "Fleet",
    description: "Forklifts, vehicles, and 90 days of inspections.",
    path: "/fleet",
    roles: FLEET_ROLES,
    component: <FleetHome />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Forklifts",
    description: "Every forklift with its status and check-in history.",
    path: "/fleet/forklifts",
    roles: FLEET_ROLES,
    component: <ForkliftList />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Forklift",
    description: "One forklift's details and 90-day check-in history.",
    path: "/fleet/forklifts/:id",
    roles: FLEET_ROLES,
    component: <ForkliftDetail />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Vehicles",
    description: "Trucks with live GPS and pre-trip inspections.",
    path: "/fleet/vehicles",
    roles: FLEET_ROLES,
    component: <VehicleList />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Vehicle",
    description: "One truck's live GPS, details, and 90-day inspections.",
    path: "/fleet/vehicles/:key",
    roles: FLEET_ROLES,
    component: <VehicleDetail />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Inspection Log",
    description: "Search 90 days of forklift and vehicle inspections.",
    path: "/fleet/inspections",
    roles: FLEET_ROLES,
    component: <InspectionLog />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Fleet Location Manager",
    description: "Branch locations, their contacts, and their forklifts.",
    path: "/fleet/forks/locationmanager",
    roles: FLEET_ROLES,
    component: <LocationManager />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Fleet Location",
    description: "One location's contacts, shifts, alert thresholds, and forklifts.",
    path: "/fleet/forks/locationmanager/:id",
    roles: FLEET_ROLES,
    component: <LocationDetail />,
    authHeader: true,
    footer: true,
  },

  {
    name: "Fleet Forklift Manager",
    description: "Redirects to Forklifts.",
    path: "/fleet/forks/forkmanager",
    roles: ["*"],
    component: <Navigate to="/fleet/forklifts" replace />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Forklift Check-In Dashboard",
    description: "Fork Check-In",
    path: "/fleet/forks/dashboard/:branch",
    roles: ["*"],
    component: <ForkDisplay />,
    authHeader: false,
    footer: false,
  },
  {
    name: "Forklift Display",
    description: "Redirects to Forklifts filtered to the branch.",
    path: "/fleet/forks/view/:location",
    roles: ["*"],
    component: <RedirectFleetView to="/fleet/forklifts" />,
    authHeader: true,
    footer: true,
  },

  {
    name: "My Forms",
    description: "View all forms submitted by the user.",
    path: "/forms/viewall",
    roles: ["*"],
    component: <ViewEntries />,
    authHeader: true,
    footer: true,
  },

  {
    name: "New RFQ Form",
    description: "Create a new RFQ form.",
    path: "/forms/new/rfq",
    roles: ["*"],
    component: <QuoteOrderForm />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Interior Door Form",
    description: "Interior Door Form",
    path: "/forms/doors/interior",
    roles: ["*"],
    component: <InteriorDoor />,
    authHeader: true,
    footer: true,
  },

  {
    name: "Schedule Orders",
    description: "Schedule Orders",
    path: "/dashboard/orders/schedule",
    roles: ["*"],
    component: <ScheduleOrders />,
    authHeader: true,
    footer: true,
  },

  {
    name: "Address Validation",
    description: "Validate an address.",
    path: "/admin/cloud/addressvalidation",
    roles: ["*"],
    component: <AddressValid />,
    authHeader: true,
    footer: true,
  },

  // Open to everyone on purpose: the page lists only the admin pages you can
  // open (Page Access grants included). Its audience in the menu is the
  // Admin Center item in NAV_SECTIONS.
  {
    name: "Admin Center",
    description: "Every admin tool on Node in one place.",
    path: "/admin",
    roles: ["*"],
    component: <AdminCenter />,
    authHeader: true,
    footer: true,
  },
  {
    name: "User Manager",
    description: "Manage users' roles, branches, page access, and account status.",
    path: "/admin/user/userManager",
    roles: ACCESS_ROLES,
    component: <UserManagement />,
    authHeader: true,
    footer: true,
    requiresMFA: false,
  },
  {
    name: "Page Access",
    description: "Let extra roles or people open a page, and create custom roles.",
    path: "/admin/access",
    roles: ACCESS_ROLES,
    component: <PageAccess />,
    authHeader: true,
    footer: true,
  },

  {
    name: "Signature Manager",
    description: "Manage company email signatures and group assignments.",
    path: "/admin/signatures",
    roles: ["Admin", "IT"],
    component: <SignatureManager />,
    authHeader: true,
    footer: true,
  },
  //Webleads V2 Routes
  {
    name: "Web Leads - Home",
    description: "Web Leads - Home",
    path: "webleads/v2/manager",
    // "Weblead Manager" was a typo for a role that doesn't exist; with route
    // roles now enforced it would have locked out the real role holders.
    roles: ["Web Lead Manager", "Admin"],
    component: <WebleadManager />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Web Leads - Summary V2",
    description: "",
    path: "webleads/summary/v2",
    roles: ["Admin"],
    component: <SummaryNew />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Help - Big C Node",
    description: "Get help with the website.",
    path: "help",
    roles: ["*"],
    component: <Help />,
    authHeader: true,
    footer: true,
  },

  {
    name: "Interior Door Slab Options",
    description: "Interior Door Slab Options",
    path: "admin/doors/slaboptions",
    roles: ["Admin"],
    component: <DoorPricing />,
    authHeader: true,
    footer: true,
  },

  {
    name: "Interior Door Admin",
    description:
      "Edit interior door pricing, slab styles, widths, and cost overrides.",
    path: "admin/doors/pricing",
    roles: ["Admin"],
    component: <DoorPricing />,
    authHeader: true,
    footer: true,
  },

  {
    name: "Big C Node - Messages",
    description:
      "Chat with coworkers — direct messages, your branch channel, and the company-wide channel, synced with the mobile app.",
    path: "/messages",
    roles: ["*"],
    component: <Messages />,
    authHeader: true,
    footer: true,
  },

  {
    name: "Page Not Found",
    description: "Page Not Found",
    path: "*",
    roles: ["*"],
    component: <NotFound />,
    authHeader: false,
  },
  {
    name: "Create Notification",
    description: "Create Notification",
    path: "/admin/createnotification",
    roles: ["Admin"],
    component: <CreateNotification />,
    authHeader: true,
    footer: true,
  },

  {
    name: "Web Leads",
    description:
      "Track, assign, and work web leads. Branch-scoped for most users; company-wide overview for Admins, Web Lead Managers, and the Executive Team.",
    path: "/webleads",
    roles: ["*"],
    component: <WebLeadsPage />,
    authHeader: true,
    footer: true,
  },

  {
    name: "Node Changes",
    description: "updates",
    path: "/admin/changes",
    roles: ["Admin"],
    component: <Changes />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Node Changelog",
    description: "update log",
    path: "/admin/changelog",
    roles: ["Admin"],
    component: <ChangeLog />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Door Builder",
    description: "Door Builder",
    path: "/windowdoor/doorbuilder",
    roles: ["Admin"],
    component: <DoorBuilder />,
    authHeader: true,
    footer: true,
  },

  {
    name: "Granger Yard Map",
    description: "Map of the granger lumber yard.",
    path: "/admin/grangeryardmap",
    roles: ["Admin"],
    component: <GrangerYardMap />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Truth Chart",
    description: "Sales rep margin report card from Bistrack.",
    path: "/truthchart",
    roles: ["Admin", "Executive Team"],
    component: <TruthChart />,
    authHeader: true,
    footer: true,
  },
  // Unlisted on purpose (per Blake): open to every signed-in user by direct
  // link, but no nav item, FAQ entry, or news — don't "fix" that.
  {
    name: "Geomapping",
    description: "Plot GPS coordinates as accuracy circles on a Google map.",
    path: "/tools/geomapping",
    roles: ["*"],
    component: <Geomapping />,
    authHeader: true,
    footer: true,
  },
  // 3D Building Designer — being tested, so (per Blake) direct link only:
  // no nav item, FAQ entry, news, or widget yet. /:id opens a saved design
  // and is the link "Share link" copies.
  {
    name: "Building Designer",
    description: "Design a post-frame building in 3D and save, share, or print it.",
    path: "/tools/building-designer",
    roles: ["*"],
    component: <BuildingDesigner />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Building Designer",
    description: "A saved 3D building design.",
    path: "/tools/building-designer/:id",
    roles: ["*"],
    component: <BuildingDesigner />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Weather",
    description: "local weather for each big c branch",
    path: "/dashboard/weather",
    roles: ["*"],
    component: <Weather />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Weather For Node",
    description: "local weather for each big c branch",
    path: "/dashboard/weather/display/:branchlocation",
    roles: ["*"],
    component: <Weather />,
    authHeader: false,
    footer: false,
  },
  {
    name: "Forklift Checklist",
    description: "Check forklift form",
    path: "/fleet/forks/forkliftform/:branch/:unit",
    roles: ["*"],
    component: <ForkliftForm />,
    authHeader: false,
    footer: false,
  },
  {
    name: "Forklift Entries",
    description: "Check forklift form",
    path: "/fleet/forks/entries/:unit",
    roles: ["*"],
    component: <DisplayEntries />,
    authHeader: false,
    footer: false,
  },
  {
    name: "Logout",
    description: "Logout",
    path: "/logout",
    roles: ["*"],
    component: <Logout />,
    authHeader: false,
    footer: false,
  },
  {
    name: "Big C Web Leads Map",
    description: "Web Lead Pin Map",
    path: "/external/webleads/:key",
    roles: ["*"],
    component: (
      <>
        <ExternalAuth externalKey="8wQPtXg9nT7bFMqWVdgne5" />
        <LeadMap display />
      </>
    ),
    authHeader: false,
    footer: false,
  },

  {
    name: "Web Lead Pin Map",
    description: "Web Lead Pin Map",
    path: "/webleads/webleadmap",
    // Shows every lead in the company — same audience as the all-locations
    // dashboard view. The /external/webleads TV display stays key-protected.
    roles: ["Web Lead Manager", "Admin", "Executive Team"],
    component: <LeadMap />,
    authHeader: true,
    footer: true,
  },

  {
    name: "Customer Certificate Data",
    description: "Customer Certificate Data",
    path: "/tax/certificates",
    roles: ["*"],
    component: <TaxCert />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Submit a Form",
    description: "Every form on the site, in one place.",
    path: "/forms",
    roles: ["*"],
    component: <FormsHub />,
    authHeader: true,
    footer: true,
  },
  {
    name: "My Submissions",
    description: "Everything you've submitted, across every form.",
    path: "/forms/my-submissions",
    roles: ["*"],
    component: <MySubmissions />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Remodel Form",
    description: "Send a remodel lead to the remodel team.",
    path: "/forms/remodel",
    roles: ["*"],
    component: <RemodelForm />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Window Service Request",
    description: "Send a window or door service issue to the shop.",
    path: "/windowdoor/service-request",
    roles: ["*"],
    component: <WindowServiceRequestForm />,
    authHeader: true,
    footer: true,
  },
  {
    name: "New Service Request (Manual Entry)",
    description: "Manager entry for phoned-in or paper service requests.",
    path: "/windowdoor/service-requests/new",
    roles: ["Window Door Manager", "Admin"],
    component: <WindowServiceRequestForm manual />,
    authHeader: true,
    footer: true,
  },
  {
    name: "My Service Requests",
    description: "Track the service requests you submitted.",
    path: "/windowdoor/my-service-requests",
    roles: ["*"],
    component: <MyServiceRequests />,
    authHeader: true,
    footer: true,
  },
  {
    name: "My Service Requests - Detail",
    description: "Track one service request you submitted.",
    path: "/windowdoor/my-service-requests/:id",
    roles: ["*"],
    component: <MyServiceRequestDetail />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Service Requests",
    description: "Work the window/door service request queue.",
    path: "/windowdoor/service-requests",
    roles: ["Window Door Manager", "Admin"],
    component: <ServiceRequestsDashboard />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Service Requests - Detail",
    description: "Work a single window/door service request.",
    path: "/windowdoor/service-requests/:id",
    roles: ["Window Door Manager", "Admin"],
    component: <ServiceRequestDetail />,
    authHeader: true,
    footer: true,
  },
  {
    // The service request form used to live here as an Admin-only mockup;
    // old bookmarks still resolve.
    name: "Window Service Request",
    description: "Redirects to the Window Service Request form.",
    path: "/windowdoor/windowservicerequestform",
    roles: ["*"],
    component: <Navigate to="/windowdoor/service-request" replace />,
    authHeader: false,
    footer: false,
  },
  {
    name: "Phone Management Tool",
    description: "Phone Management Tool",
    path: "/admin/managephone",
    roles: ["Admin"],
    component: <ManagePhone />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Vehicle Manager",
    description: "Redirects to Vehicles.",
    path: "/fleet/vehiclemanager",
    roles: ["*"],
    component: <Navigate to="/fleet/vehicles" replace />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Vehicle Display",
    description: "Redirects to Vehicles filtered to the branch.",
    path: "/fleet/vehiclemanager/view/:location",
    roles: ["*"],
    component: <RedirectFleetView to="/fleet/vehicles" />,
    authHeader: true,
    footer: true,
  },
  {
    name: "BigC SharePoint",
    description: "Big C sharepoint file system",
    path: "/dashboard/sharepoint",
    roles: ["*"],
    component: <SharePoint />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Lead Without Contact",
    description: "Webleads without contact",
    path: "/webleads/nocontact",
    roles: ["Web Lead Manager", "Admin", "Executive Team"],
    component: <WithoutContact />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Converted To Sale",
    description: "Leads converted to sale",
    path: "/webleads/convertedtosale",
    roles: ["Web Lead Manager", "Admin", "Executive Team"],
    component: <ConvertedToSale />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Customer KPI's",
    description: "Customer KPI data",
    path: "/dashboard/CustomerKPIs",
    roles: ["*"],
    component: <CustomerKPIs />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Request Webtrack Access",
    description: "Request Webtrack Access",
    path: "/misc/webtrackaccess",
    roles: ["*"],
    component: <RequestAccess />,
    authHeader: false,
    footer: false,
  },
  {
    name: "Truss and Panel Documents",
    description: "Truss and Panel Documents",
    path: "/sbcf/documents",
    roles: ["*"],
    component: <CommonStock />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Big C User Portal",
    description: "Big C User Portal",
    path: "/admin/user/portal",
    roles: ["Admin"],
    component: <UserPortal />,
    authHeader: true,
    footer: true,
    requiresMFA: true,
  },
  {
    name: "Big C User Portal Checklist",
    description: "Big C User Portal Checklist",
    path: "/admin/user/portal/checklist",
    roles: ["Admin"],
    component: <UserChecklist />,
    authHeader: true,
    footer: true,
    requiresMFA: true,
  },

  {
    name: "Interior Door Form Summary",
    description: "Interior Door Form Summary",
    path: "/forms/IntDoorFormSummary",
    roles: ["Admin", "Executive Team"],
    component: <InteriorDoorFormSummary />,
    authHeader: true,
    footer: true,
    requiresMFA: false,
  },
  {
    name: "Caught in the Act Form",
    description: "Caught in the Act Form",
    path: "/forms/recognition",
    roles: ["*"],
    component: <RecognitionForm />,
    authHeader: true,
    footer: true,
    requiresMFA: false,
  },
  {
    name: "Caught in the Act Form Mobile",
    description: "Caught in the Act Form",
    path: "/mobile/forms/recognition/:name/:mobile",
    roles: ["*"],
    component: <RecognitionForm />,
    authHeader: false,
    footer: false,
    requiresMFA: false,
  },
  {
    name: "Caught in the Act Entries",
    description: "Caught in the Act Entries",
    path: "/forms/recognition/entries",
    roles: ["Manager", "Admin"],
    component: <RecognitionEntries />,
    authHeader: true,
    footer: true,
    requiresMFA: false,
  },
  {
    name: "Sales Dashboard",
    description: "Sales Dashboard",
    path: "/sales/dashboard",
    roles: ["*"],
    component: <CRMDashboard />,
    authHeader: true,
    footer: true,
    requiresMFA: false,
  },
  {
    name: "2025 Big C Step Challenge",
    description: "2025 Big C Step Challenge",
    path: "/StepChallenge",
    roles: ["*"],
    component: <StepCompetition />,
    authHeader: false,
    footer: false,
    requiresMFA: false,
  },
  {
    name: "Webtrack Monitor",
    description: "Webtrack Monitor",
    path: "/monitor",
    roles: ["*"],
    component: <WebtrackMonitor />,
    authHeader: true,
    footer: true,
    requiresMFA: false,
  },

  {
    name: "Material List AI Test",
    description: "Material List AI Test",
    path: "/AiMaterialList",
    roles: ["*"],
    component: <MaterialListAi />,
    authHeader: true,
    footer: true,
    requiresMFA: false,
  },
  {
    name: "Order Problem Form",
    description: "Report an order problem.",
    path: "/forms/order-problem",
    roles: ["*"],
    component: <OrderProblemForm />,
    authHeader: true,
    footer: true,
    requiresMFA: false,
  },
  {
    name: "Order Problems Dashboard",
    description: "View and manage reported order problems.",
    path: "/order-problems",
    roles: ["Admin", "Executive Team"],
    component: <OrderProblemsDashboard />,
    authHeader: true,
    footer: true,
    requiresMFA: false,
  },
  {
    name: "Request a Feature or Change",
    description:
      "Ask for a new feature, a change to something existing, or report something broken.",
    path: "/forms/feature-request",
    roles: ["*"],
    component: <FeatureRequestForm />,
    authHeader: true,
    footer: true,
    requiresMFA: false,
  },
  {
    name: "Feature Requests Dashboard",
    description: "Triage and track feature and change requests from staff.",
    path: "/admin/feature-requests",
    roles: ["Admin", "IT"],
    component: <FeatureRequestsDashboard />,
    authHeader: true,
    footer: true,
    requiresMFA: false,
  },
  {
    name: "PCW Hours",
    description:
      "Punch in/out hours by work order, worker, and category; job schedule and due dates; manage PCW workers and categories.",
    path: "/pcw",
    roles: ["Admin", "PCW Admin"],
    component: <PCWDashboard />,
    authHeader: true,
    footer: true,
    requiresMFA: false,
  },
  {
    name: "Mill Shop Hours",
    description:
      "Mill - Fort Wayne shop clock: punch in/out hours by work order and worker; job schedule and due dates; manage Mill shop workers.",
    path: "/mill-shop",
    roles: ["Admin", "Mill Admin"],
    component: <MillShopDashboard />,
    authHeader: true,
    footer: true,
    requiresMFA: false,
  },
  {
    name: "Toolbox Talks",
    description: "Watch safety toolbox talk videos.",
    path: "/safety/toolbox-talks",
    roles: ["*"],
    component: <ToolboxTalks />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Safety Overview",
    description:
      "What needs attention across safety concerns, fire extinguishers, training, and toolbox talks, by branch.",
    path: "/safety/overview",
    roles: SAFETY_ROLES,
    component: <SafetyOverview />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Safety Concerns",
    description: "Safety concerns reported from the mobile app, with photos and notes.",
    path: "/safety/concerns",
    roles: SAFETY_ROLES,
    component: <SafetyConcerns />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Fire Extinguishers",
    description: "Every fire extinguisher and its monthly inspections.",
    path: "/safety/extinguishers",
    roles: SAFETY_ROLES,
    component: <FireExtinguishers />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Training Videos",
    description: "Upload and assign training videos and track who's done or overdue.",
    path: "/safety/training",
    roles: SAFETY_ROLES,
    component: <TrainingVideos />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Training Video",
    description: "Who a training video is assigned to; assign or unassign people and roles.",
    path: "/safety/training/:id",
    roles: SAFETY_ROLES,
    component: <TrainingVideoDetail />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Toolbox Talk Results",
    description: "Who has finished each toolbox talk; upload new talks.",
    path: "/safety/toolbox-results",
    roles: SAFETY_ROLES,
    component: <ToolboxResults />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Mobile App Codes",
    description:
      "Text or email Node Mobile download codes; import codes from Apple Business Manager.",
    path: "/admin/app-codes",
    roles: APP_CODES_ROLES,
    component: <AppCodes />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Assistant Usage",
    description:
      "How people use the Node Mobile assistant and Siri, and what they ask for that it can't do yet.",
    path: "/admin/assistant-usage",
    roles: ASSISTANT_USAGE_ROLES,
    component: <AssistantUsage />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Monthly Feedback",
    description:
      "What people send from the monthly feedback popup, who dismissed it, and when each person sees it next.",
    path: "/admin/feedback",
    roles: FEEDBACK_ROLES,
    component: <MonthlyFeedback />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Digital Signage",
    description:
      "Manage the Raspberry Pi signage displays: register devices, upload media, and build playlists.",
    path: "/signage",
    roles: ["Admin", "Executive Team", "General Manager"],
    component: <SignageDashboard />,
    authHeader: true,
    footer: true,
  },
  {
    name: "SBCF RFQ Form",
    description: "SBCF RFQ Form",
    path: "/sbcf/rfq",
    roles: ["*"],
    component: <BlueprintSpecSheet />,
    authHeader: true,
    footer: true,
  },
  {
    name: "SBCF Sales Schedule",
    description: "SBCF Sales Schedule",
    path: "/sbcf",
    roles: ["*"],
    component: <SBCFDashboard />,
    authHeader: true,
    footer: true,
  },
  {
    name: "SBCF Admin",
    description: "SBCF spec sheet queue, team workload, and form admin",
    path: "/sbcfadmin",
    roles: ["Admin", "SBCF Admin", "SBCF Assigner", "SBCF Team"],
    component: <SBCFAdminDashboard />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Big C Website Editor",
    description: "Big C Website Editor",
    path: "/admin/webeditor",
    roles: ["Web Admin", "Admin"],
    component: <WebsiteEditor />,
    authHeader: true,
    footer: true,
  },
  {
    name: "Mill Document Scanner",
    description: "Mill Document Scanner",
    path: "/mill/scanner/:key",
    roles: ["*"],
    component: (
      <>
        <ExternalAuth externalKey="8wQPtXg12ij3o1zkxWVdgne5" />
        <MillScanner />
      </>
    ),
    authHeader: false,
    footer: true,
  },
  // Public on purpose: the status page must stay reachable when ADFS
  // sign-in itself is having problems.
  {
    name: "Big C Node - Site Status",
    description: "Live status of the Big C Node site and server.",
    path: "/status",
    roles: ["*"],
    component: <SiteStatus />,
    authHeader: false,
    footer: false,
  },
];
